import { Drawer } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { AppDispatch } from '../../../../store/app';
import { getAsteriskViewStatusList } from '../../../../store/NumberManagementSlice';
import { useDispatch } from 'react-redux';
import { CONSTANT } from '../../../../config/Constant';

const SendAsteriskViewStatus: React.FC<any> = (props) => {
  const { handleViewStatus, openViewStatusDrawer, openViewStatusData } = props;
  const dispatch: AppDispatch = useDispatch();
  const [listData, setListData] = useState<any>();
  const getViewStatusList = useCallback(
    (id: string) => {
      const payload = {
        id: id,
      };
      dispatch(getAsteriskViewStatusList(payload))
        .then((res: any) => {
          setListData(res?.data);
        })
        .catch((error: any) => {
          console.log('error', error);
          setListData([]);
        });
    },
    [dispatch],
  );

  useEffect(() => {
    if (openViewStatusData?._id) {
      getViewStatusList(openViewStatusData?._id);
    }
  }, [getViewStatusList, openViewStatusData]);

  const statusList = (data) => {
    return (
      <>
        <thead>
          <tr>
            <th style={{ width: '30%' }}>Provider</th>
            <th style={{ width: '30%' }}>Network Identity</th>
            <th style={{ width: '30%' }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {data?.length > 0 ? (
            data.map((item: any) => {
              return (
                <tr key={item._id}>
                  <td>{item.provider_name}</td>
                  <td>{item.network_identity}</td>
                  <td>{item.status}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={3}>{CONSTANT.NO_DATA_FOUND}</td>
            </tr>
          )}
        </tbody>
      </>
    );
  };

  return (
    <>
      <Drawer
        open={openViewStatusDrawer}
        destroyOnClose
        width={900}
        onClose={handleViewStatus}
        footer={false}
        className="addModal"
        title={`View Asterisk Status`}
      >
        <table
          className="reportTable"
          width={'100%'}
        >
          {statusList(listData)}
        </table>
      </Drawer>
    </>
  );
};
export default SendAsteriskViewStatus;
